import { defineMessages } from 'react-intl';

export const messages: {
	newLozengeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	segmentationToggleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	segmentationToggleLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label-v2',
		defaultMessage: 'Target audience',
		description:
			'A visible label for the toggle to display/hide segmentation configuration for type text based link card',
	},
	newLozengeLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label-v2',
		defaultMessage: 'New',
		description: 'A visible label for the new lozenge',
	},
});
